"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var core_1 = require("@material-ui/core");
exports.useStyles = (0, core_1.makeStyles)(function () { return (0, core_1.createStyles)({
    styleAccordion: {
        color: '#2B304F',
        boxShadow: 'none',
        backgroundColor: '#0000 !important',
        margin: '0 !important'
    },
    positionAccordionSummary: {
        alignItems: "center",
        justifyContent: "flex-start"
    },
    font: {
        fontFamily: "Inter",
        overflowHidden: 'x',
    },
    title: {
        fontFamily: "Inter",
        fontSize: 16,
        fontWeight: 600,
    },
    titleLeft: {
        fontFamily: "Inter",
        fontSize: 16,
        fontWeight: 600,
        marginLeft: 10
    },
    contentGrid: {
        padding: '10px 10px 20px 10px',
        fontFamily: "Inter",
        color: '#2B304F',
    },
    contentsGrid: {
        padding: '0px 24px 24px 24px',
        display: 'grid',
    },
    contentsWithoutHeader: {
        padding: '24px 24px 24px 24px',
        display: 'grid',
    },
    summary: {
        height: 20
    },
    displayHeader: {
        display: 'none'
    }
}); });
